import React from 'react'
import { Link, useForm, usePage } from '@inertiajs/inertia-react'
import AlertDismissible from '../../../Shared/Components/AlertDismissible'
import Breadcrumbs from '../../../Shared/Components/Breadcrumbs'
import Layout from '../../../Shared/Layout/LayoutAdmin'
import PaginationList from '../../../Shared/Components/PaginationList'
import Row from 'react-bootstrap/Row'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import UserAvatar from '../../../Shared/Components/UserAvatar'

const UsersIndex = ({ users, filters }) => {
    const { flash } = usePage().props
    const data = users.data

    const filterForm = useForm({
        search: filters.search || '',
    })

    const submitFilters = (e) => {
        e.preventDefault()
        filterForm.get(route('admin.users.list'), { preserveState: true })
    }

    const clearFilters = () => {
        filterForm.setData({ search: '' })
        filterForm.get(route('admin.users.list'))
    }

    const paginationFilters = {
        search: filters.search || undefined,
    }

    const roleLabel = (row) => row.roles?.[0]?.name || '—'

    return (
        <Row>
            {flash.success && <AlertDismissible message={flash.success} type="success" />}
            <span className="pb-7 pt-7">
                <Breadcrumbs currentPath="/admin/users" />
            </span>

            <div className="card card-flush h-md-100">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">Usuarios (Admin / Owner)</span>
                    </h3>
                    <div className="card-toolbar">
                        <Link href={route('admin.users.create')} className="btn btn-sm btn-primary">
                            Agregar usuario
                        </Link>
                    </div>
                </div>

                <div className="card-body pt-6">
                    <Form onSubmit={submitFilters} className="d-flex flex-wrap align-items-end gap-3 mb-8">
                        <div className="flex-grow-1" style={{ minWidth: '220px', maxWidth: '420px' }}>
                            <label className="form-label fs-7 fw-bold text-gray-600 mb-2">Buscar</label>
                            <Form.Control
                                type="search"
                                className="form-control form-control-sm form-control-solid"
                                placeholder="Nombre o correo…"
                                value={filterForm.data.search}
                                onChange={(e) => filterForm.setData('search', e.target.value)}
                            />
                        </div>
                        <Button type="submit" size="sm" variant="primary" disabled={filterForm.processing}>
                            Buscar
                        </Button>
                        <Button type="button" size="sm" variant="light" onClick={clearFilters}>
                            Limpiar
                        </Button>
                    </Form>

                    <div className="table-responsive">
                        <table className="table table-row-dashed align-middle gs-0 gy-3 my-0">
                            <thead>
                                <tr className="fs-7 fw-bold text-gray-400 border-bottom-0">
                                    <th className="p-0 pb-3 text-start" style={{ width: '56px' }}>Foto</th>
                                    <th className="p-0 pb-3 text-start">Nombre</th>
                                    <th className="p-0 pb-3 text-start">Correo</th>
                                    <th className="p-0 pb-3 text-start">Rol</th>
                                    <th className="p-0 pb-3 text-start">Activo</th>
                                    <th className="p-0 pb-3 text-start">Email verificado</th>
                                    <th className="p-0 pb-3 text-end"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 && (
                                    <tr>
                                        <td colSpan={7} className="px-6 py-3 text-center text-gray-800 fw-bold fs-6">
                                            No hay datos.
                                        </td>
                                    </tr>
                                )}
                                {data.map((row) => (
                                    <tr key={row.id}>
                                        <td>
                                            <UserAvatar src={row.photo_url} size={40} alt={row.name} />
                                        </td>
                                        <td>
                                            <p className="text-gray-800 fw-bold mb-1 fs-6">{row.name}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 mb-1 fs-6">{row.email}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 mb-1 fs-6">{roleLabel(row)}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-800 mb-1 fs-6">{row.status ? 'Sí' : 'No'}</p>
                                        </td>
                                        <td>
                                            <p className="text-gray-600 mb-1 fs-7">{row.email_verified_at || '—'}</p>
                                        </td>
                                        <td className="text-end">
                                            <Link href={route('admin.users.edit', row.id)}>Editar</Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="d-flex justify-content-center py-6">
                        <PaginationList links={users.links} filters={paginationFilters} />
                    </div>
                </div>
            </div>
        </Row>
    )
}

UsersIndex.layout = (page) => <Layout title="Usuarios">{page}</Layout>

export default UsersIndex
